import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Services.css';
import { useTranslation } from 'react-i18next';

const Servicios = () => {
  const { t } = useTranslation();
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="page-hero modern-page-hero">
        <div className="page-hero-pattern"></div>
        <div className="page-hero-overlay"></div>
        <Container>
          <div className="page-hero-content text-center">
            <div className="hero-badge animate-appear" style={{ display: 'inline-block', background: '#2563eb', color: '#fff', borderRadius: '20px', padding: '0.5rem 1.5rem', fontWeight: 700, fontSize: '1.1rem', marginBottom: '1rem' }}>
              {t('servicesPage.hero.badge')}
            </div>
            <h1 className="animate-appear" style={{ fontWeight: 800, fontSize: '2.8rem', marginTop: '1rem' }}>{t('servicesPage.hero.title')}</h1>
            <p className="animate-appear" style={{ fontSize: '1.25rem', maxWidth: 700, margin: '1.5rem auto 0', color: '#444' }}>
              {t('servicesPage.hero.subtitle')}
            </p>
          </div>
        </Container>
      </section>

      {/* Main Services Section */}
      <section className="section modern-section">
        <Container>
          <Row className="g-4">
            {/* SOFT SERVICES */}
            <Col lg={4} md={6}>
              <Card className="modern-card h-100 shadow-sm">
                <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/services/support.jpg'} alt={t('servicesPage.mainServices.soft.title')} style={{height:'220px',objectFit:'cover'}} />
                <Card.Body>
                  <h2 className="modern-service-title mt-3 mb-2" style={{ fontWeight: 700 }}>{t('servicesPage.mainServices.soft.title')}</h2>
                  <ul className="service-details-list modern-details-list">
                    {t('servicesPage.mainServices.soft.details', { returnObjects: true }).map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            {/* HARD SERVICES */}
            <Col lg={4} md={6}>
              <Card className="modern-card h-100 shadow-sm">
                <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/industries/electromechanical.jpg'} alt={t('servicesPage.mainServices.hard.title')} style={{height:'220px',objectFit:'cover'}} />
                <Card.Body>
                  <h2 className="modern-service-title mt-3 mb-2" style={{ fontWeight: 700 }}>{t('servicesPage.mainServices.hard.title')}</h2>
                  <ul className="service-details-list modern-details-list">
                    {t('servicesPage.mainServices.hard.details', { returnObjects: true }).map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            {/* ENGINEERING SERVICES */}
            <Col lg={4} md={12}>
              <Card className="modern-card h-100 shadow-sm">
                <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/services/engineering.jpg'} alt={t('servicesPage.mainServices.engineering.title')} style={{height:'220px',objectFit:'cover'}} />
                <Card.Body>
                  <h2 className="modern-service-title mt-3 mb-2" style={{ fontWeight: 700 }}>{t('servicesPage.mainServices.engineering.title')}</h2>
                  <ul className="service-details-list modern-details-list">
                    {t('servicesPage.mainServices.engineering.details', { returnObjects: true }).map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section cta-section modern-cta">
        <Container className="text-center">
          <h2 className="cta-title">{t('servicesPage.cta.title')}</h2>
          <p className="cta-description">
            {t('servicesPage.cta.description')}
          </p>
          <Link to="/contacto">
            <Button variant="primary" className="modern-button">
              {t('servicesPage.cta.button')}
            </Button>
          </Link>
        </Container>
      </section>
    </div>
  );
};

export default Servicios; 